import type { ReviewSummary } from "@/interfaces/review";

interface RatingSummaryProps {
  summary?: ReviewSummary;
}

export default function RatingSummary({ summary }: RatingSummaryProps) {
  console.log("SUMMARY", summary);
  if (!summary) return null;

  const { negativeReviews, positiveReviews, totalReviews } = summary;

  const recommendationPercentage =
    totalReviews > 0
      ? Math.round(((positiveReviews + negativeReviews) / totalReviews) * 100)
      : 0;

  return (
    <div className="rounded-3xl shadow-sm">
      <div className="">
        <div className="rounded-2xl border border-primary/15 bg-gradient-to-br from-primary/10 via-background to-background p-5 shadow-sm backdrop-blur-sm">
          <p className="text-lg font-semibold tracking-tight">
            {recommendationPercentage}% of users recommend this merchant.
          </p>

          <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
            This score is calculated from verified trading reviews submitted by
            users after completed transactions.
          </p>
        </div>
      </div>
    </div>
  );
}
